<page-load-header *ngIf="!initialized"></page-load-header>

<h3>{{data}}</h3>

<button class="btn btn-primary" type="button" (click)="loadData()">Load Data</button>
<div *ngIf="initialized" class="container-fluid">

</div>
